import PropTypes from "react";

const ModalComponent = ({
  showModal,
  setShowModal,
  children,
  width,
  handleClose,
}) => {
  return (
    <div>
      {showModal && (
        <div className="min-w-screen h-screen animated fadeIn faster px-5 md:px-0  fixed  left-0 top-0 flex justify-center items-center inset-0 z-50 outline-none focus:outline-none bg-no-repeat bg-center bg-cover">
          <div
            // x-show={showModal}
            onClick={() => handleClose()}
            className="absolute transition-colors  ease-in duration-1000 bg-black  backdrop-blur opacity-40 inset-0 z-0"
          ></div>
          <div
            className={` w-full ${width} relative mx-auto my-auto rounded shadow-lg  bg-white`}
          >
            <div className="flex flex-col items-center justify-center">
              {children}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ModalComponent;
